var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.info.supplier)+"授权给"+_vm._s(_vm.info.customer)+"  "),(_vm.online)?_c('span',[_vm._v(_vm._s(_vm.info.duration)+"  "+_vm._s(_vm.info.chapters))]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }